import { MODEL_METADATA } from "../../../common/reserved-names";
import { actionMenuItemActionableIsExpandable, actionMenuItemIsActionable } from "./utils";
export const addMetadataInActionMenuItem = (itemUIModel, parentItem) => {
    itemUIModel[MODEL_METADATA] = {
        parentItem
    };
};
export const getActionMenuItemMetadata = (itemUIModel) => itemUIModel[MODEL_METADATA];
export const parseSubModel = (parentModel, parentItem) => {
    // For loop is the fastest iterator
    for (let index = 0; index < parentModel.length; index++) {
        const itemUIModel = parentModel[index];
        addMetadataInActionMenuItem(itemUIModel, parentItem);
        if (actionMenuItemIsActionable(itemUIModel) &&
            actionMenuItemActionableIsExpandable(itemUIModel)) {
            parseSubModel(itemUIModel.items, itemUIModel);
        }
    }
};
